// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"8944a32c","372":"6b6690c3","738":"7a751e3e","856":"fc259354","858":"39f4fe02"}[chunkId] + ".chunk.js";
};